import { getOs } from '../services/mobile';
import { parsedUrl } from '../services/url';

import {
  DISPLAY_MODE_UPDATED,
  DISPLAY_TYPE_UPDATED,
  PAGE_LOAD,
  PAGE_NOT_LOADED,
  RECEIVE_CDC_DATA,
  RECEIVE_PCD_DATA,
  TOGGLE_FILTERS
} from '../actions/shared';

import {
  FETCH_SEARCH_RESULTS,
  SELECT_POINTS_OF_SALE,
  RECEIVE_SEARCH_RESULTS
} from '../actions/pointOfSale';

import { INTEGRATION_MODE_QUERY_PARAMETER } from '../settings/shared';
import { DISPLAY_MODE_MAP } from 'ui-kit/src/components/FilterBlock/FilterBlock';

export const DISPLAY_TYPE_MOBILE = 0;
export const DISPLAY_TYPE_DESKTOP = 1;

const initialState = {
  dataCdc: null,
  dataPcd: null,
  displayType: window.matchMedia('(min-width: 992px)').matches ? DISPLAY_TYPE_DESKTOP : DISPLAY_TYPE_MOBILE,
  displayMode: DISPLAY_MODE_MAP,
  filtersIsOpen: window.matchMedia('(min-width: 992px)').matches,
  integrationMode: parsedUrl.query[INTEGRATION_MODE_QUERY_PARAMETER],
  isLoaderVisible: false,
  isGeolocationAvailable: navigator
    && navigator.geolocation
    && navigator.geolocation.getCurrentPosition
    && true,
  mobileOs: getOs(),
  pageLoadState: PAGE_NOT_LOADED
};

export function shared(state = initialState, action) {
  switch (action.type) {
    case DISPLAY_MODE_UPDATED:
      return {
        ...state,
        displayMode: action.data,
        filtersIsOpen: false
      };

    case DISPLAY_TYPE_UPDATED:
      return {
        ...state,
        displayType: action.data
      };

    case FETCH_SEARCH_RESULTS:
      return {
        ...state,
        isLoaderVisible: true,
      };

    case PAGE_LOAD:
      return {
        ...state,
        pageLoadState: action.loadState
      };

    case RECEIVE_CDC_DATA:
      return {
        ...state,
        dataCdc: action.data
      };

    case RECEIVE_PCD_DATA:
      return {
        ...state,
        dataPcd: action.data
      };

    case RECEIVE_SEARCH_RESULTS:
      return {
        ...state,
        isLoaderVisible: false,
      };

    case SELECT_POINTS_OF_SALE:
      return {
        ...state,
        filtersIsOpen: false
      };

    case TOGGLE_FILTERS:
      return {
        ...state,
        filtersIsOpen: !state.filtersIsOpen
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shared.js